module.exports = __webpack_public_path__ + "img/3_1.ffc69d6b.jpg";